var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
var StyledInfoBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  background-color: #E9F1F8;\n  padding: 10px 1rem;\n  .info{\n    font-family: 'AvenirHeavy';\n    margin-right: 2rem;\n  }\n  .text{\n    font-family: 'AvenirLight';\n  }\n"], ["\n  display: flex;\n  background-color: #E9F1F8;\n  padding: 10px 1rem;\n  .info{\n    font-family: 'AvenirHeavy';\n    margin-right: 2rem;\n  }\n  .text{\n    font-family: 'AvenirLight';\n  }\n"])));
var InfoBox = function (_a) {
    var label = _a.label, text = _a.text;
    return _jsxs(StyledInfoBox, { children: [_jsx("div", __assign({ className: "info" }, { children: label })), text && _jsx("div", __assign({ className: "text" }, { children: text }))] });
};
export default InfoBox;
var templateObject_1;
